module.exports = __webpack_public_path__ + "img/logo-dark.0bad4a52.png";